import { useEffect } from 'react';

const resize = (elName) => {
  const doc = document.querySelector(`#${elName}`);
  doc.style.height = 'auto';
  doc.style.height = `${doc.scrollHeight}px`;
};

export const useAutoResize = (value, elName) => {
  useEffect(() => {
    resize(elName);
  }, [value, elName]);
};
